export default __webpack_public_path__ + "static/media/StarEmpty.ec397be9.svg";